import $ from "jquery"
import Vue from 'vue'
import App from './App.vue'
import VModal from 'vue-js-modal'
import money from 'v-money'
import datePicker from 'vue-bootstrap-datetimepicker'
import store from './store'
// Import Bootstrap CSS
import 'select2';
import 'select2/dist/css/select2.css'
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootswatch/dist/morph/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import VueSkeletonLoader from 'skeleton-loader-vue';
import 'dotenv/config'
require('dotenv').config()
import globals from './globals.js'

import VueMask from 'v-mask'

Vue.use(globals);

// Register the component globally
Vue.component('vue-skeleton-loader', VueSkeletonLoader);
 

window.$ = $
Vue.use(VueMask);
Vue.use(VModal)
Vue.use(money, {precision: 4})
Vue.use(datePicker);

Vue.config.productionTip = false

new Vue({
  store, 
  render: h => h(App),
}).$mount('#app')
